import { Injectable } from '@angular/core';
import { isNullOrUndefined } from '@app/utiles/javascript';
import { DatosToken, Permisos, TipoAmbitos, TipoGrupos, TipoPermiso } from './storage.modelo';

@Injectable()
export class StorageService {
  private readonly keysLocalStorage = {
    token: 'access_token',
    empresa_id: 'id_empresa_seleccionada',
    nombre_empresa: 'nombre_empresa_seleccionada',
    ambito_id: 'ambito_id',
    grupo_id: 'grupo_id',
    permisos: 'permisos',
    sucursal_id: 'sucursal_id',
    sucursal_abreviatura: 'sucursal_abreviatura',
    existe_tienda_pf: 'existe_tienda_pf',
    sociedad_id: 'sociedad_id',
  };
  private getIdFromCurrentUrl(key: 'empresa' | 'sucursal') {
    const hashPath = globalThis.location?.hash?.replace(/^#/, '') || '';
    const pathname = globalThis.location?.pathname || '';
    const currentPath = hashPath || pathname;
    const match = new RegExp(`/${key}/([^/?#]+)`).exec(currentPath);
    if (!match) return null;
    const id = Number.parseInt(match[1], 10);
    return Number.isNaN(id) ? null : id;
  }
  private decodificarToken(): DatosToken {
    const token = localStorage.getItem(this.keysLocalStorage.token);
    if (!token) return { roles: [] } as DatosToken;
    const base64Url = token.split('.')[1];
    if (!base64Url) return { roles: [] } as DatosToken;
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  }
  setEmpresa(empresa_id: number, nombre: string) {
    localStorage.setItem(this.keysLocalStorage.empresa_id, empresa_id ? empresa_id.toString() : null);
    localStorage.setItem(this.keysLocalStorage.nombre_empresa, nombre);
  }
  setGrupoId(grupo_id: number) {
    localStorage.setItem(this.keysLocalStorage.grupo_id, grupo_id ? grupo_id.toString() : null);
  }
  setAmbitoId(ambito_id: number) {
    localStorage.setItem(this.keysLocalStorage.ambito_id, ambito_id ? ambito_id.toString() : null);
  }
  getNombreEmpresa() {
    return localStorage.getItem(this.keysLocalStorage.nombre_empresa);
  }
  getEmpresaID() {
    return this.getIdFromCurrentUrl('empresa') ?? (Number.parseInt(localStorage.getItem(this.keysLocalStorage.empresa_id), 10) || null);
  }
  getAmbitoID(): TipoAmbitos {
    return JSON.parse(localStorage.getItem(this.keysLocalStorage.ambito_id));
  }
  getGrupoID(): TipoGrupos {
    return localStorage.getItem(this.keysLocalStorage.grupo_id) as TipoGrupos;
  }
  getIsAdmin() {
    return this.decodificarToken().roles.some(rol => ['ROLE_DEIPE-ADMIN'].includes(rol));
  }

  getIsSoporte() {
    return this.decodificarToken().roles.some(rol => ['ROLE_DEIPE-SOPORTE'].includes(rol));
  }
  private getPermisos() {
    const permisosLocalStorage = JSON.parse(localStorage.getItem(this.keysLocalStorage.permisos) || '{}') as Permisos;
    if(!permisosLocalStorage) return {};
    return permisosLocalStorage;
  }
  getPermiso(nombrePermiso: TipoPermiso) {
    if(this.getIsAdmin()) return true;
    const permisos = this.getPermisos();
    return (permisos[nombrePermiso] === 'S' || permisos[nombrePermiso] === 'T');
  }
  setSucursalId(sucursal_id: number) {
    if(isNullOrUndefined(sucursal_id)) return localStorage.setItem(this.keysLocalStorage.sucursal_id, null);
    localStorage.setItem(this.keysLocalStorage.sucursal_id, sucursal_id.toString());
  }
  setSucursalAbreviatura(sucursalAbreviatura: string) {
    if(isNullOrUndefined(sucursalAbreviatura)) return localStorage.setItem(this.keysLocalStorage.sucursal_abreviatura, null);
    localStorage.setItem(this.keysLocalStorage.sucursal_abreviatura, sucursalAbreviatura);
  }
  getSucursalId() {
    return this.getIdFromCurrentUrl('sucursal') ?? JSON.parse(localStorage.getItem(this.keysLocalStorage.sucursal_id) || null);
  }
  getSucursalAbreviatura() {
    return localStorage.getItem(this.keysLocalStorage.sucursal_abreviatura) || null;
  }
  setSociedadId(sociedad_id: number) {
    if(isNullOrUndefined(sociedad_id)) return localStorage.setItem(this.keysLocalStorage.sociedad_id, null);
    localStorage.setItem(this.keysLocalStorage.sociedad_id, sociedad_id.toString());
  }
  getSociedadId() {
    return JSON.parse(localStorage.getItem(this.keysLocalStorage.sociedad_id) || null);
  }
}
